var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"imgs"}),_c('div',{staticClass:"hotline"},[_c('div',{staticClass:"telBox"})])])
}]

export { render, staticRenderFns }